module.exports = __webpack_public_path__ + "static/media/list-fill-primary.91b7d15e.svg";